import { useEffect } from "react";
import { ChangeLanguage } from "../helpers";
import { useQueryParams } from "../hooks/useQueryParams";
import { SUPPORTED_LANGUAGES } from "../i18n";
export default function withLanguage(Component: () => JSX.Element) {
    return function LanguageWrapper(props: any) {
        let params = useQueryParams();
        useEffect(() => {
            const paramsLang: any = params.get("lang");
            if (!!paramsLang && SUPPORTED_LANGUAGES.includes(paramsLang)) {
                ChangeLanguage(paramsLang);
            }
        }, []);
        return <Component {...props} />;
    };
}
